export function generalTabDataMapper(caseData) {
  if (Object.keys(caseData ?? {}).length === 0) {
    return {};
  }

  return {
    name: caseData.name,
    incidentType: caseData.incidentType,
    incidentRole: caseData.incidentRole,
    incidentLocation: caseData.incidentLocation,
    incidentCity: caseData.incidentCity,
    status: caseData.status,
    legalStatus: caseData.legalStatus,
    overallStatus: caseData.overallStatus,
    dateOfAccident: caseData.dateOfAccident,
    statuteOfLimitations: caseData.statuteOfLimitations,
    campaign: caseData.campaign,
    incidentDescription: caseData.incidentDescription,
    updatedAt: caseData.updatedAt,
    updatedBy: caseData.updatedBy,
    createdAt: caseData.createdAt,
    createdBy: caseData.createdBy,
  };
}
export function propertyDamageTabDataMapper(caseData) {
  if (Object.keys(caseData ?? {}).length === 0) {
    return {};
  }

  return {
    providerMax: caseData.providerMax,
    movingViolation: caseData.movingViolation,
    propertyDamageSeverity: caseData.propertyDamageSeverity,
    propertyDamageAmount: caseData.propertyDamageAmount,
    policeReportNumber: caseData.policeReportNumber,
    updatedAt: caseData.updatedAt,
    updatedBy: caseData.updatedBy,
    createdAt: caseData.createdAt,
    createdBy: caseData.createdBy,
  };
}
